function hasSucceededTransaction(item) {
  return (
    Array.isArray(item?.transition) &&
    item.transition.some((t) => t?.status === "succeeded")
  );
}

export function filterActiveMemberships(
  data,
  subscriptionType,
  subscriptionId = null
) {
  const memberships = Array.isArray(data) ? data.filter(Boolean) : [];

  const validMemberships = memberships.filter((item) => {
    const isNotExpired = item?.expired === false || item?.expired === "false";
    return isNotExpired && hasSucceededTransaction(item);
  });

  const hasMembership = validMemberships.length > 0;
  const everPaid = memberships.some(hasSucceededTransaction);

  // A subscriptionId can exist on the user without any charge ever having
  // succeeded (e.g. a declined card, or a subscription left incomplete) -
  // that case is "Payment Failed", not "Expired": nothing was ever active.
  let status = "Inactive";
  if (subscriptionId && hasMembership) {
    status = "Active";
  } else if (subscriptionId && everPaid) {
    status = "Expired";
  } else if (subscriptionId) {
    status = "Payment Failed";
  }

  return {
    hasMembership,
    memberships: validMemberships,
    subscriptionType,
    subscriptionId,
    status,
  };
}
